// extracted by mini-css-extract-plugin
export default {"topic-title":"ThemeContainer_topic-title__txUi3","topic-body-list":"ThemeContainer_topic-body-list__snoRq"};